<template>
  <div class="root_card-bg" @click.prevent.stop="useBg">
    <div class="card">
      <!--封面-->
      <div
        class="bgpic"
        :style="{
          background:
            'url(' +
            $handleAssetsUrl(bgItem.thumbnailUrl) +
            ') center/cover no-repeat',
        }"
      >
        <!--静态-->
        <div class="static">
          <div class="rt-panel">
            <div class="business" v-if="bgItem.isCommerical"></div>
            <img
              v-if="bgItem.company"
              class="companyicon"
              :src="$handleAssetsUrl(bgItem.companyIcon)"
            />
          </div>
          <!-- <div
            class="viponly"
            v-if="
              bgItem.payType == 1 || bgItem.payType == 4 || bgItem.payType == 6
            "
          >
            <div
              :class="{
                vip: bgItem.payType == 4,
                compvip: bgItem.payType == 6,
                bought: bgItem.payType == 1 && bgItem.tt,
              }"
            ></div>
          </div>
          <div
            class="rb-price"
            v-if="bgItem.payType == 1 && bgItem.tt && UserMsg.levelType < 2"
          >
            <span class="discount" v-if="bgItem.originalPrice && !bgItem.tt">{{
              '￥' + bgItem.originalPrice
            }}</span>
            <span v-if="!bgItem.tt">{{ '￥' + bgItem.price }}</span>
          </div> -->
          <PayTypeSubscript
            :item="bgItem"
            style="right: 4px; bottom: 4px"
          ></PayTypeSubscript>
          <div class="is-dynamic" v-if="bgItem.fileType === 25"></div>
        </div>

        <!--悬浮-->
        <div
          class="hover"
          @mouseenter.prevent.stop="playvideo"
          @mouseleave.prevent.stop="stopvideo"
        >
          <video
            class="video"
            v-if="bgItem.fileType == 25"
            ref="myvideo"
            :src="$handleAssetsUrl(bgItem.url)"
            @canplay="loadedvideo"
          ></video>
          <!-- <el-button
            type="primary"
            size="mini"
            round
            class="use-rightnow"
            @click.prevent.stop="useBg"
          >添加到画布</el-button>-->
          <div class="rt-panel">
            <div class="collect">
              <div
                :class="bgItem.favorites ? 'like' : 'dislike'"
                @click.prevent.stop="favoriteClick"
              ></div>
            </div>
            <el-tooltip
              popper-class="emodel-template-lib-bg-item"
              effect="dark"
              :content="bgItem.company"
              placement="top"
            >
              <img
                v-if="bgItem.company"
                class="companyicon"
                :src="$handleAssetsUrl(bgItem.companyIcon)"
              />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//isCommerical
import { mapGetters, mapMutations } from 'vuex';
import transTempTypeMixin from '../../../../mixins/trans-temp-type';
import PayTypeSubscript from '@/components/common/materialPayTypeSubscript';
export default {
  mixins: [transTempTypeMixin],
  props: {
    bgItem: {
      type: Object,
      required: true,
      default: () => {},
    },
    direction: {
      type: String,
      default: '1', //1横2竖
    },
  },
  components: {
    PayTypeSubscript,
  },
  data() {
    return {
      ispopover: false,
      coverUrl: this.$handleAssetsUrl(this.bgItem.thumbnailUrl),
      videoEle: null,
    };
  },
  methods: {
    playvideo() {
      if (this.videoEle) this.videoEle.play();
    },
    stopvideo() {
      if (this.videoEle) {
        this.videoEle.pause();
        this.videoEle.currentTime = 0;
      }
    },
    loadedvideo(e) {
      this.videoEle = e.target;
    },
    previewClick() {
      this.$emit('previewClick', this.bgItem);
    },
    trackSearchResultClick(item = {}) {
      if (!this.$parent.keyword) {
        return;
      }
      sensors.track('searchResultClick', {
        choose_price: this.trackingData.choose_price,
        click_type: '添加到画布',
        keyword_type: this.trackingData.keyword_type,
        keyword: this.trackingData.keyword,
        order_method: this.trackingData.order_method,
        position_number: '',
        search_source: '编辑器素材弹窗',
        template_id: this.$route.template || '',
        template_name: '',
        template_style: '',
        template_type: '',
        material_id: item.id || '',
        // material_name: item.title || "",
      });
    },
    useBg() {
      let data = this.bgItem;
      this.$bus.emit('beforeAddToCanvas', { data, type: 'background' });
      this.trackSearchResultClick(data);
      let type =
        data.fileType === 25 || data.fileType === 26 ? 'Video' : 'Image';
      //let sceneBgProps = this.SelectScenes_Msg.background;
      //console.log('tmp lib use BG', data);
      let bgOpts = {
        // 设置场景背景
        resourceId: data.id, // 背景资源id
        fileType: data.fileType, // 背景资源type
        type, // 背景类型 0:Color 1:Image 2:Video
        source: data.source,
        data: {
          // 颜色背景的数据
          url: data.url, // 颜色值,8位数
          blur: 0, // 高斯模糊
          opacity: 1, // 透明度
        },
        videoStartTime: 0,
        videoEndTime: parseInt(this.SelectScenes_Msg.duration / 1000),
        zoomActive: false,
      };

      if (type === 'Video') {
        //console.log('type === "Video"',data)
        this.$bus.emit('confirmAddVideo', {
          type: 'bg', // 'bg' 'sprite'
          data: data,
        });
      } else {
        this.SelectScenes_Msg.setBackground(bgOpts, null, true);
        this.$bus.emit('judgeItemPayType_vue', {
          type: 'bg',
          id: 'BG-' + this.SelectScenes_Msg.id,
          option: {
            resourceId: data.id, // 背景资源id
            fileType: data.fileType, // 背景资源type
          },
          opHelper: {
            isSvip: false,
          },
          scenesId: this.SelectScenes_Msg.id,
        });
      }
      this.$store.commit('del_vipSprites', {
        id: 'BG-' + this.SelectScenes_Msg.id,
      });

      this.$store.commit('close_TemplateMaterialLibDialogMsg');
    },
    favoriteClick() {
      let params = { id: this.bgItem.id, type: 3 };
      if (this.bgItem.favorites) {
        params.isCancel = 1;
      }
      let item = this.bgItem;
      let postBody = params;
      item.sprite = item;
      this.trackCollectContent({ ...item, collect_content: '背景' }, postBody);
      this.$http.post('/api/user/favorites', params).then(({ data }) => {
        if (data.code !== 200) return;
        this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
        this.bgItem.favorites = !this.bgItem.favorites;
      });
    },
    showLikesToast (type = 'likes') {
      if (type === 'likes') {
        this.$message({
          message: "收藏成功",
          type: "success",
        });
      }
      if (type === 'unlikes') {
        this.$message('收藏已取消');
      }
    },
    trackCollectContent(item, dict) {
      sensors.track('collectContent', {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: '',
        collect_content: item.collect_content || '',
        content_duration: this.TOOL.getDuration() / 1000,
        content_id: this.WorksId,
        content_name: this.WorksName,
        material_id: item.id,
        // material_name: item.title,
        module: '编辑器素材弹窗',
        operation_type: dict.isCancel == 1 ? '取消收藏' : '收藏',
        price_type: ((payType) => {
          if (payType == 0) {
            return '免费';
          }
          if (payType == 1) {
            return '付费';
          }
          if (payType == 4) {
            return '会员免费';
          }
          return '全部价格';
        })(item.payType || (item.sprite || {}).payType),
        price: (item.price || (item.sprite || {}).price || 0) - 0,
        purpose: '',
        template_id: this.$route.template || '',
        template_name: '',
        template_style: '',
        template_type: '',
      });
    },
  },
  computed: {
    ...mapGetters([
      'isRealVip',
      'SelectScenes_Msg',
      'UserMsg',
      'WorksId',
      'WorksName',
      'TOOL',
    ]),
    ...mapGetters({
      trackingData: 'tracking/trackingData',
    }),
  },
  mounted() {
    //console.log('UserMsg', this.UserMsg, this.bgItem);
  },
  filters: {},
};
</script>

<style lang="scss" scoped>
.root_card-bg {
  .card {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 4px;
    //overflow: hidden;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0);
    transition: all 0.2s linear;
    position: relative;
    &:hover {
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      transform: scale(1.1);
      .bgpic {
        border-radius: 5px;
        .static {
          opacity: 0;
        }
        .hover {
          opacity: 1;
        }
      }
      .title-price {
        opacity: 0;
        height: 0px;
      }
    }
    .bgpic {
      flex: 1;
      position: relative;
      border-radius: 5px;
      .static {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: all 0.15s linear;
        .rb-price {
          position: absolute;
          right: 3px;
          bottom: 4px;
          height: 18px;
          line-height: 18px;
          background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
          border-radius: 4px;
          font-size: 10px;
          color: #ffffff;
          padding: 0px 4px 0 2px;
          .discount {
            float: left;
            text-decoration: line-through;
          }
        }
        .viponly {
          position: absolute;
          right: 3px;
          bottom: 4px;
          height: 16px;
          .vip {
            float: right;
            width: 36px;
            height: 16px;
            background-image: url(../../../../../../static/svg/payTypeSubscript/vip36x16.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .compvip {
            float: right;
            width: 50px;
            height: 16px;
            background-image: url(../../../../../../static/svg/payTypeSubscript/companyVip50x16.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .bought {
            float: right;
            width: 50px;
            height: 16px;
            background-image: url(../../../../../../static/svg/payTypeSubscript/bought50x16.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          //background-image: url(../../../../../../static/svg/template-material-lib/common/viponly.svg);
        }
        .rt-panel {
          position: absolute;
          right: 3px;
          top: 3px;
          width: 100%;
          height: 24px;
          .business {
            margin: 0 4px 0 0;
            float: right;
            width: 20px;
            height: 24px;
            background-image: url(../../../../../../static/svg/template-material-lib/common/business.svg);
          }
          .companyicon {
            position: relative;
            float: right;
            margin: 2px 4px 2px 0;
            float: right;
            height: 20px;
          }
        }
      }
      .hover {
        width: 100%;
        height: 100%;
        font-size: 12px;
        position: absolute;
        transition: all 0.2s linear;
        opacity: 0;
        .use-rightnow {
          position: absolute;
          font-size: 12px;
          left: 4px;
          bottom: 4px;
          width: 88px;
          height: 28px;
        }
        .rt-panel {
          top: 4px;
          right: 4px;
          width: 100%;
          height: 20px;
          position: absolute;
          .collect {
            float: right; //为子元素设定值
            width: 24px;
            height: 100%;
            background-color: #ffffffaa;
            border-radius: 6px;
            padding: 4px 0 0 6px;
            .like {
              height: 12px;
              width: 12px;
              background-image: url(../../../../../../static/svg/template-material-lib/common/like.svg);
            }
            .dislike {
              height: 12px;
              width: 12px;
              background-image: url(../../../../../../static/svg/template-material-lib/common/dislike.svg);
            }
            &:hover {
              background-color: #ffffff;
            }
          }
          // .company {
          //   z-index: 1000000000;
          //   left: -80px;
          //   top: -50px;
          //   border-radius: 4px;
          //   position: absolute;
          //   width: 200px;
          //   height: 40px;
          //   line-height: 40px;
          //   background-color: #333;
          // }
          .companytext {
            color: yellow;
          }
          .companyicon {
            position: relative;
            float: left;
            margin: 0 4px 0 0;
            float: right;
            //width: 20px;
            height: 100%;
          }
        }
        .video {
          border-radius: 4px;
          top: 0;
          left: 0;
          overflow: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
    .title-price {
      width: 100%;
      height: 24px;
      overflow: hidden;
      transition: all 0.15s linear;
      .temp-des {
        width: 100px;
        height: 100%;
        float: left;
        overflow: hidden;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        position: relative;
        //border-bottom: 1px solid #f0eff5;
        .des-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
          letter-spacing: 1px;
          font-size: 12px;
          text-align: left;
          padding-top: 0px;
        }
      }
      .temp-info {
        color: #ff3a3f;
        height: 30px;
        float: right;
        display: flex;
        font-size: 12px;
        overflow: hidden;
        align-items: center;
        justify-content: space-between;
        .info-price {
          margin: 0 10px 0 0;
          height: 100%;
          display: flex;
          align-items: center;
          .pay-type {
            height: 100%;
            align-items: center;
            display: flex;
            color: #ff3a3f;
            &.price {
              color: #ff3a3f;
            }
          }
        }
      }
    }
  }
}
.is-dynamic {
  width: 14px;
  height: 14px;
  background-image: url(../../../../../../static/svg/resources-area/video-type.svg);
  background-size: 100% 100%;
  position: absolute;
  left: 6px;
  bottom: 6px;
  z-index: 20;
}
</style>

<style lang="scss">
// .el-popover {
//   &.el-popper {
//     &.emodel-template-lib-bg-item {
//       border-radius: 4px;
//       width: 200px;
//       height: 40px;
//       line-height: 40px;
//       background-color: #333;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/background/backgroundItem.vue